module.exports = "<nav class=\"navbar navbar-light nav-custom-bar\">\n  <a class=\"navbar-brand\" href=\"https://uniandes.edu.co\" id=\"logo-andes\">\n    <img src=\"./assets/img/uniandes.svg\" class=\"img\" alt=\"Universidad de Los Andes\" title=\"Universidad de Los Andes\">\n  </a>\n</nav>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/navbar/navbar.component.html
// module id = ./src/app/shared/navbar/navbar.component.html
// module chunks = main